var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:{'is-dark': _vm.dark, 'is-invert': _vm.invert, 'is-loading': _vm.loading},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }